import {StyleParamType, wixColorParam, wixFontParam, createStylesParams} from '@wix/tpa-settings'

export type TextStylesParams = {
  textBreadcrumbsFont: StyleParamType.Font
  textBreadcrumbsColor: StyleParamType.Color
  textListTitleFont: StyleParamType.Font
  textListTitleColor: StyleParamType.Color
  textExperienceNameFont: StyleParamType.Font
  textExperienceNameColor: StyleParamType.Color
  textExperienceSummaryFont: StyleParamType.Font
  textExperienceSummaryColor: StyleParamType.Color
  textExperienceDetailsFont: StyleParamType.Font
  textExperienceDetailsColor: StyleParamType.Color
}

export const textStylesParams = createStylesParams<TextStylesParams>({
  textBreadcrumbsFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 16}),
  },
  textBreadcrumbsColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-text-primary'),
  },
  textListTitleFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Page-title', {size: 32}),
  },
  textListTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-title'),
  },
  textExperienceNameFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 24}),
  },
  textExperienceNameColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-title'),
  },
  textExperienceSummaryFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 16}),
  },
  textExperienceSummaryColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-text-primary'),
  },
  textExperienceDetailsFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 16}),
  },
  textExperienceDetailsColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-text-primary'),
  },
})
